let previousTime = 0;
function clickTarget(timeOut: number): boolean {
  const currentTime = new Date().getTime();
  const differ = currentTime - previousTime;
  if (differ > timeOut) {
    console.log("click", new Date(currentTime));
    previousTime = new Date().getTime();
    return false;
  } else {
    return true;
  }
}
function formatFunc(str: number) {
  //格式化显示
  return str > 9 ? str : "0" + str;
}
function fromatDateYM(date2: Date): string {
  const year = date2.getFullYear();
  const mon = formatFunc(date2.getMonth() + 1);
  const day = formatFunc(date2.getDate());
  const hour = formatFunc(date2.getHours());
  // hour = hour < 10 ? "0" + hour : hour;
  let min = date2.getMinutes() as any;
  min = min <= 10 ? "0" + min : min;
  let seconds = date2.getSeconds() as any;
  seconds = seconds <= 10 ? "0" + seconds : seconds;
  const dateStr =
    year + "-" + mon + "-" + day + " " + hour + ":" + min + ":" + seconds;
  return dateStr;
}
function fromatDateYMD(date2: Date): string {
  const year = date2.getFullYear();
  const mon = formatFunc(date2.getMonth() + 1);
  const day = formatFunc(date2.getDate());
  const dateStr = year + "-" + mon + "-" + day;
  return dateStr;
}

function dateFormat(fmt: string, date: Date): string {
  let ret;
  const opt = new Map<string, string>();
  opt.set("Y+", date.getFullYear().toString());
  opt.set("m+", (date.getMonth() + 1).toString());
  opt.set("d+", date.getDate().toString());
  opt.set("H+", date.getHours().toString());
  opt.set("M+", date.getMinutes().toString());
  opt.set("S+", date.getSeconds().toString());
  opt.forEach((val, k) => {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      const val = opt.get(k) as string;
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? val : val?.padStart(ret[1].length, "0")
      );
    }
  });
  return fmt;
}

function fromatDateYMDHMS(UTCDateString: string | number): string {
  if (!UTCDateString) {
    return "-";
  }
  const date2 = new Date(UTCDateString); //这步是关键
  const year = date2.getFullYear();
  const mon = formatFunc(date2.getMonth() + 1);
  const day = formatFunc(date2.getDate());
  const hour = date2.getHours();
  const mhour = formatFunc(hour);
  const min = formatFunc(date2.getMinutes());
  const seconds = date2.getSeconds();
  const dateStr =
    year + "-" + mon + "-" + day + " " + mhour + ":" + min + ":" + seconds;
  return dateStr;
}
let lastClickTime = 0;
const delayClick = (): boolean => {
  console.log("延迟点击判断");
  const curTime = new Date().getTime();
  if (curTime - lastClickTime > 500) {
    lastClickTime = curTime;
    return true;
  } else {
    return false;
  }
};
export {
  clickTarget,
  fromatDateYM,
  fromatDateYMD,
  dateFormat,
  fromatDateYMDHMS,
  delayClick,
};
